import type { Mission } from '../missions.ts'

export const fletc: Mission = {
  id: "fletc",
  name: "Federal Law Enforcement Training Centers",
  short: "FLETC",
  call: "Training",
  kind: "subagency",
  parent: "dhs",
  url: "https://www.fletc.gov/",
  established: 1970,
  palette: {
    primary: "#135986",
    secondary: "#9aa2aa",
    accent: "#d21e49",
  },
  colorSource: {
    kind: "seal",
    url: "https://commons.wikimedia.org/wiki/File:FLETC_2025_seal.png",
  },
  motif: "torch",
  mission: {
    text: "FLETC’s mission is to train and support the training of federal, state, local, and tribal law enforcement officers and international partners that are responsible for enforcing laws, treaties, and regulations within the United States and abroad.",
    url: "https://www.fletc.gov/mission-values",
  },
  fact: {
    text: "Since its founding in 1970, FLETC has grown into the Nation’s largest provider of law enforcement training.",
    url: "https://www.fletc.gov/about",
  },
  seal: {
    file: "public/seals/fletc.png",
    source: "https://commons.wikimedia.org/wiki/File:FLETC_2025_seal.png",
  },
  identifier: {
    about: "https://www.fletc.gov/about",
    accessibility: "https://www.fletc.gov/website-policies-and-notices",
    foia: "https://www.fletc.gov/freedom-information-act-foia",
    noFear: "https://www.fletc.gov/no-fear-act",
    oig: "https://www.oig.dhs.gov/",
    performance: "https://www.dhs.gov/performance-financial-reports",
    privacy: "https://www.fletc.gov/website-policies-and-notices",
  },
  media: {
    photos: [
      {
        file: "/media/fletc-driving-course.jpg",
        small: "/media/fletc-driving-course-sm.jpg",
        alt: "A gray police SUV speeds across a wet skid pad as sprinklers spray water on the FLETC driver training course.",
        title: "FLETC driving course, Charleston, South Carolina, November 7, 2025",
        creator: "Tia Dufour, U.S. Department of Homeland Security",
        source: "https://commons.wikimedia.org/wiki/File:Federal_Law_Enforcement_Training_Centers_(FLETC)_driving_course_and_Charleston_development_at_FLETC_in_Charleston,_South_Carolina,_Nov._7,_2025_-_6.jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/fletc-tactical-training.jpg",
        small: "/media/fletc-tactical-training-sm.jpg",
        alt: "Four officers in vests holding red training rifles move in a single-file stack along a brick wall during tactical training.",
        title: "Tactical entry training at the Federal Law Enforcement Training Centers, Glynco, Georgia, April 13, 2022",
        creator: "U.S. Immigration and Customs Enforcement",
        source: "https://commons.wikimedia.org/wiki/File:ICE_Enforcement_and_Removal_Operations_(ERO)_deportation_officers_move_in_a_stack_prior_to_entering_a_building_during_training_at_the_Federal_Law_Enforcement_Training_Center_(FLETC)_in_Glencoe_Georgia_on_April_13,_2022_(52257989282).jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
